import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import DonorListSampleType from './DonorListSampleType';

function SampleTypeDropdown({ samples, selectedSamples, handleSampleChange, setSelectedSamples, type, label }) {
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    return (
          <Dropdown className={`${type ==='jobBoard'? "" : "d-inline-block "}`}>
            <Dropdown.Toggle variant={type === 'jobBoard' ? "secondary  jobboard-date-btn" : "primary"}  className={`p-0 ${type ==='jobBoard'? "navbar-drop-buttons" : ''} `} id="dropdown-basic">
                       {label || (type === "donationhistory" ? ("Status") : type === ("location") ? ("Lab Location") : type===("from") ? ("From") : type===("bcc") ? ("BCC") : ("Sample Type"))}
            </Dropdown.Toggle>

            <Dropdown.Menu  className="el-admin dropdwon-st" renderOnMount={true} 
                popperConfig={{
                    strategy: "fixed",
                    placement: "bottom-start",
                    modifiers: [
                    {
                        name: "flip",
                        enabled: false
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: "clippingParents" //  Use nearest scrollable container
                        }
                    },
                    {
                        name: "computeStyles",
                        options: {
                            adaptive: false //  Prevent dynamic reposition glitch while scrolling
                        }
                    }
                ]
                }}>
                <form>
                     {samples.map((sample) => (
                        <DonorListSampleType
                            label={sample.label}
                            selectedSamples={selectedSamples}
                            key={sample.id}
                            sample={sample}  
                            id={sample.id}
                            handleSampleChange={handleSampleChange}
                        />
                    ))}
                </form>
                <div>
                    <input
                        type="button" value="Clear All"
                        className="btn btn-link"
                        onClick={() => setSelectedSamples([])}
                    />
                </div>
            </Dropdown.Menu>
        </Dropdown>

        // <Dropdown  
        // className={`d-inline-block ${type=='jobBoard'? "form-control" : ""}`} 
        // // show={showDropdown}    
        // // onClick={()=>{toggleDropdown()}}
        // >
        //     <Dropdown.Toggle   variant={type === 'jobBoard' ? "secondary" : "primary"} className={`p-0 ${type ==='jobBoard'? "navbar-drop-buttons" : ''} `} id="statusFilterDropdown">
        //         {/* {type !=="location"  ? ("Sample Type") : ("Lab location")} */}

        //         {type === "donationhistory" ? ("Status") : type === ("location") ? ("Lab Location") : type===("from") ? ("From") : type===("bcc") ? ("BCC") : ("Sample Type")}
        //     </Dropdown.Toggle>

        //     <Dropdown.Menu>
        //         <form>
        //             {samples.map((sample) => (
        //                 <DonorListSampleType
        //                     label={sample.label}
        //                     selectedSamples={selectedSamples}
        //                     key={sample.id}
        //                     sample={sample}  
        //                     id={sample.id}
        //                     handleSampleChange={handleSampleChange}
        //                 />
        //             ))}
        //         </form>
        //         <div>
        //             <input
        //                 type="button" value="Clear All"
        //                 className="btn btn-link"
        //                 onClick={() => setSelectedSamples([])}
        //             />
        //         </div>
        //     </Dropdown.Menu>
        // </Dropdown>
    );
}

export default SampleTypeDropdown;
